// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (
  modules,
  entry,
  mainEntry,
  parcelRequireName,
  externals,
  distDir,
  publicUrl,
  devServer
) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var importMap = previousRequire.i || {};
  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        if (externals[name]) {
          return externals[name];
        }
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        globalObject
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      if (res === false) {
        return {};
      }
      // Synthesize a module to follow re-exports.
      if (Array.isArray(res)) {
        var m = {__esModule: true};
        res.forEach(function (v) {
          var key = v[0];
          var id = v[1];
          var exp = v[2] || v[0];
          var x = newRequire(id);
          if (key === '*') {
            Object.keys(x).forEach(function (key) {
              if (
                key === 'default' ||
                key === '__esModule' ||
                Object.prototype.hasOwnProperty.call(m, key)
              ) {
                return;
              }

              Object.defineProperty(m, key, {
                enumerable: true,
                get: function () {
                  return x[key];
                },
              });
            });
          } else if (exp === '*') {
            Object.defineProperty(m, key, {
              enumerable: true,
              value: x,
            });
          } else {
            Object.defineProperty(m, key, {
              enumerable: true,
              get: function () {
                if (exp === 'default') {
                  return x.__esModule ? x.default : x;
                }
                return x[exp];
              },
            });
          }
        });
        return m;
      }
      return newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.require = nodeRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.distDir = distDir;
  newRequire.publicUrl = publicUrl;
  newRequire.devServer = devServer;
  newRequire.i = importMap;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  // Only insert newRequire.load when it is actually used.
  // The code in this file is linted against ES5, so dynamic import is not allowed.
  // INSERT_LOAD_HERE

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });
    }
  }
})({"dLydd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _progressBar = require("hooks-starter/ProgressBar");
"use client";
exports.default = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _progressBar.ProgressBar), {
    label: "Loading\u2026",
    value: 80
});

},{"react/jsx-runtime":"2Is6Z","hooks-starter/ProgressBar":"hQHuP","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"hQHuP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ProgressBar", ()=>ProgressBar);
var _jsxRuntime = require("react/jsx-runtime");
var _useProgressBar = require("react-aria/useProgressBar");
var _progressBarCss = require("./ProgressBar.css");
var _formCss = require("./Form.css");
'use client';
function ProgressBar(props) {
    let { label, value = 0, minValue = 0, maxValue = 100, isIndeterminate } = props;
    /*- begin highlight -*/ let { progressBarProps, labelProps } = (0, _useProgressBar.useProgressBar)(props);
    /*- end highlight -*/ // Calculate the width of the progress fill as a percentage.
    let percentage = (value - minValue) / (maxValue - minValue) * 100;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        ...progressBarProps,
        className: "react-aria-ProgressBar",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                className: "react-aria-Label",
                ...labelProps,
                children: label
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                className: "value",
                children: progressBarProps['aria-valuetext']
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "track inset",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "fill",
                    style: {
                        '--percent': (isIndeterminate ? 100 : percentage) + '%'
                    }
                })
            })
        ]
    });
}

},{"react/jsx-runtime":"2Is6Z","react-aria/useProgressBar":"4o0wp","./ProgressBar.css":"hS0mc","./Form.css":"c6lBL","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"hS0mc":[function() {},{}],"c6lBL":[function() {},{}],"gP3id":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                cx: 10,
                cy: 10.021,
                r: 1.5,
                fill: "var(--iconPrimary, light-dark(rgb(41, 41, 41), rgb(219, 219, 219)))"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, light-dark(rgb(41, 41, 41), rgb(219, 219, 219)))",
                d: "M10 8.5c-.828 0-1.5.672-1.5 1.5s.672 1.5 1.5 1.5 1.5-.672 1.5-1.5-.672-1.5-1.5-1.5"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                cx: 4,
                cy: 10.021,
                r: 1.5,
                fill: "var(--iconPrimary, light-dark(rgb(41, 41, 41), rgb(219, 219, 219)))"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                cx: 4,
                cy: 10,
                r: 1.5,
                fill: "var(--iconPrimary, light-dark(rgb(41, 41, 41), rgb(219, 219, 219)))"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                cx: 16,
                cy: 10.021,
                r: 1.5,
                fill: "var(--iconPrimary, light-dark(rgb(41, 41, 41), rgb(219, 219, 219)))"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                cx: 16,
                cy: 10,
                r: 1.5,
                fill: "var(--iconPrimary, light-dark(rgb(41, 41, 41), rgb(219, 219, 219)))"
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"kmqkh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, light-dark(rgb(41, 41, 41), rgb(219, 219, 219)))",
            d: "M7.75 16.465c-.187 0-.374-.07-.52-.21-.298-.287-.308-.762-.02-1.06l4.999-5.197-4.986-5.184c-.288-.297-.279-.772.02-1.06.296-.286.774-.278 1.06.021L13.79 9.48c.28.29.28.749 0 1.039l-5.5 5.716c-.146.154-.344.23-.54.23"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"ivjAn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, light-dark(rgb(41, 41, 41), rgb(219, 219, 219)))",
            d: "M5.313 18.748c-1.04 0-2.08-.396-2.873-1.188-1.584-1.584-1.584-4.163 0-5.747l3.906-3.906c1.585-1.584 4.162-1.583 5.747 0q.327.329.566.71c.22.35.115.814-.235 1.034-.353.222-.814.115-1.034-.235q-.152-.241-.36-.45c-.999-.998-2.625-.997-3.624.002l-3.905 3.905c-.999 1-.999 2.627 0 3.626 1.001 1.001 2.627.997 3.626 0l1.952-1.952c.293-.293.768-.293 1.06 0s.294.767 0 1.06L8.189 17.56c-.792.792-1.834 1.187-2.875 1.188m8.341-6.655 3.906-3.905c1.584-1.585 1.584-4.164 0-5.748s-4.164-1.584-5.747 0L9.86 4.393c-.293.293-.293.767 0 1.06s.768.293 1.06 0l1.953-1.952c1-.998 2.625-1 3.626 0 .999.999.999 2.626 0 3.626l-3.905 3.905c-1 1-2.625 1-3.624.001q-.208-.207-.36-.449c-.22-.35-.681-.457-1.034-.235-.35.22-.456.683-.235 1.034q.24.381.566.71c.793.792 1.833 1.188 2.874 1.188 1.04 0 2.081-.396 2.873-1.188"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"erT5A":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, light-dark(rgb(41, 41, 41), rgb(219, 219, 219)))",
            d: "M3.755 7.243c.287-.299.762-.308 1.06-.02l5.183 4.986 5.197-4.999c.298-.288.773-.278 1.06.02.287.297.278.773-.02 1.06l-5.717 5.5c-.29.28-.75.28-1.04 0L3.776 8.303c-.153-.147-.23-.344-.23-.54 0-.188.07-.375.21-.52"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"6imrL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, light-dark(rgb(41, 41, 41), rgb(219, 219, 219)))",
                d: "M11.75 18h-7.5C3.01 18 2 16.99 2 15.75v-7.5C2 7.01 3.01 6 4.25 6c.414 0 .75.336.75.75s-.336.75-.75.75c-.413 0-.75.337-.75.75v7.5c0 .413.337.75.75.75h7.5c.413 0 .75-.337.75-.75 0-.414.336-.75.75-.75s.75.336.75.75c0 1.24-1.01 2.25-2.25 2.25M6.75 5C6.336 5 6 4.664 6 4.25 6 3.01 7.01 2 8.25 2c.414 0 .75.336.75.75s-.336.75-.75.75c-.413 0-.75.337-.75.75 0 .414-.336.75-.75.75M13 3.5h-2c-.414 0-.75-.336-.75-.75S10.586 2 11 2h2c.414 0 .75.336.75.75s-.336.75-.75.75"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, light-dark(rgb(41, 41, 41), rgb(219, 219, 219)))",
                d: "M13 14h-2c-.414 0-.75-.336-.75-.75s.336-.75.75-.75h2c.414 0 .75.336.75.75s-.336.75-.75.75M15.75 14c-.414 0-.75-.336-.75-.75s.336-.75.75-.75c.413 0 .75-.337.75-.75 0-.414.336-.75.75-.75s.75.336.75.75c0 1.24-1.01 2.25-2.25 2.25M17.25 5c-.414 0-.75-.336-.75-.75 0-.413-.337-.75-.75-.75-.414 0-.75-.336-.75-.75s.336-.75.75-.75C16.99 2 18 3.01 18 4.25c0 .414-.336.75-.75.75M17.25 9.75c-.414 0-.75-.336-.75-.75V7c0-.414.336-.75.75-.75s.75.336.75.75v2c0 .414-.336.75-.75.75M6.75 9.75C6.336 9.75 6 9.414 6 9V7c0-.414.336-.75.75-.75s.75.336.75.75v2c0 .414-.336.75-.75.75M8.25 14C7.01 14 6 12.99 6 11.75c0-.414.336-.75.75-.75s.75.336.75.75c0 .413.337.75.75.75.414 0 .75.336.75.75s-.336.75-.75.75"
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"k8LxT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, light-dark(rgb(41, 41, 41), rgb(219, 219, 219)))",
                d: "M10 18.78c-4.825 0-8.75-3.926-8.75-8.75S5.175 1.28 10 1.28s8.75 3.924 8.75 8.75-3.925 8.75-8.75 8.75m0-16c-3.998 0-7.25 3.251-7.25 7.25s3.252 7.25 7.25 7.25 7.25-3.253 7.25-7.25S13.998 2.78 10 2.78"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, light-dark(rgb(41, 41, 41), rgb(219, 219, 219)))",
                d: "M13.25 9.25h-2.5v-2.5c0-.414-.336-.75-.75-.75s-.75.336-.75.75v2.5h-2.5c-.414 0-.75.336-.75.75s.336.75.75.75h2.5v2.5c0 .414.336.75.75.75s.75-.336.75-.75v-2.5h2.5c.414 0 .75-.336.75-.75s-.336-.75-.75-.75"
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"jifhr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, light-dark(rgb(41, 41, 41), rgb(219, 219, 219)))",
                d: "M13.53 9.427c-.292-.292-.766-.294-1.06 0l-1.717 1.714V2.75c0-.414-.336-.75-.75-.75s-.75.336-.75.75v8.4L7.53 9.426c-.293-.293-.767-.293-1.06 0s-.293.767 0 1.06l2.998 2.998c.146.147.338.22.53.22.191 0 .384-.073.53-.22l3.002-2.998c.293-.292.293-.767 0-1.06"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, light-dark(rgb(41, 41, 41), rgb(219, 219, 219)))",
                d: "M15.75 18H4.25C3.01 18 2 16.99 2 15.75v-2.021c0-.415.336-.75.75-.75s.75.335.75.75v2.021c0 .413.337.75.75.75h11.5c.413 0 .75-.337.75-.75v-2.021c0-.415.336-.75.75-.75s.75.335.75.75v2.021c0 1.24-1.01 2.25-2.25 2.25"
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"brg0k":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, light-dark(rgb(41, 41, 41), rgb(219, 219, 219)))",
                d: "M18 15.75V4.25C18 3.01 16.99 2 15.75 2H4.25C3.01 2 2 3.01 2 4.25v3.718c0 .414.336.75.75.75s.75-.336.75-.75V4.25c0-.414.336-.75.75-.75h11.5c.414 0 .75.336.75.75v11.5c0 .414-.336.75-.75.75h-3.811c-.414 0-.75.336-.75.75s.336.75.75.75h3.811c1.24 0 2.25-1.01 2.25-2.25"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, light-dark(rgb(41, 41, 41), rgb(219, 219, 219)))",
                d: "M11 9.75v4.243c0 .414-.336.75-.75.75s-.75-.336-.75-.75V11.56l-6.47 6.47c-.146.146-.338.219-.53.219s-.384-.073-.53-.22c-.293-.293-.293-.767 0-1.06l6.47-6.47H6.006c-.414 0-.75-.336-.75-.75s.336-.75.75-.75h4.243c.414 0 .75.336.75.75"
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"h0Yh9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, light-dark(rgb(41, 41, 41), rgb(219, 219, 219)))",
                d: "M4.75 14c-.183 0-.367-.066-.512-.201-.302-.282-.319-.757-.037-1.06l2.576-2.765-2.576-2.765c-.282-.304-.265-.778.037-1.06s.78-.266 1.06.037l3.054 3.276c.268.288.268.735 0 1.023l-3.053 3.277C5.15 13.92 4.95 14 4.75 14"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, light-dark(rgb(41, 41, 41), rgb(219, 219, 219)))",
                d: "M16.75 17H3.25C2.01 17 1 15.99 1 14.75v-9.5C1 4.01 2.01 3 3.25 3h13.5C17.99 3 19 4.01 19 5.25v9.5c0 1.24-1.01 2.25-2.25 2.25M3.25 4.5c-.413 0-.75.337-.75.75v9.5c0 .413.337.75.75.75h13.5c.413 0 .75-.337.75-.75v-9.5c0-.413-.337-.75-.75-.75z"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, light-dark(rgb(41, 41, 41), rgb(219, 219, 219)))",
                d: "M15.25 14h-5.5c-.414 0-.75-.336-.75-.75s.336-.75.75-.75h5.5c.414 0 .75.336.75.75s-.336.75-.75.75"
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"921LY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, light-dark(rgb(41, 41, 41), rgb(219, 219, 219)))",
                d: "M10 18.795c-.601 0-1.166-.234-1.591-.66l-6.545-6.544c-.876-.877-.876-2.305 0-3.182l6.545-6.545c.849-.85 2.333-.85 3.182 0l6.545 6.545c.876.877.876 2.305 0 3.182l-6.545 6.545c-.425.425-.99.659-1.591.659m0-16.09c-.2 0-.389.078-.53.22L2.925 9.47c-.292.292-.292.768 0 1.06l6.545 6.545c.283.283.778.283 1.06 0l6.545-6.545c.292-.292.292-.768 0-1.06L10.53 2.925c-.141-.142-.33-.22-.53-.22"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, light-dark(rgb(41, 41, 41), rgb(219, 219, 219)))",
                d: "M10 14.998c-.231.008-.456-.073-.627-.228-.33-.365-.33-.92 0-1.285.17-.158.395-.242.626-.234.237-.01.466.08.633.247.162.168.25.394.242.627.012.235-.07.465-.228.639-.174.164-.408.25-.647.234M10 11.625c-.414 0-.75-.336-.75-.75v-5c0-.414.336-.75.75-.75s.75.336.75.75v5c0 .414-.336.75-.75.75"
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"8rNDD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, light-dark(rgb(41, 41, 41), rgb(219, 219, 219)))",
                d: "M10 18.78c-4.825 0-8.75-3.926-8.75-8.75S5.175 1.28 10 1.28s8.75 3.924 8.75 8.75-3.925 8.75-8.75 8.75m0-16c-3.998 0-7.25 3.251-7.25 7.25s3.252 7.25 7.25 7.25 7.25-3.253 7.25-7.25S13.998 2.78 10 2.78"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, light-dark(rgb(41, 41, 41), rgb(219, 219, 219)))",
                d: "M13.25 10.75h-6.5c-.414 0-.75-.336-.75-.75s.336-.75.75-.75h6.5c.414 0 .75.336.75.75s-.336.75-.75.75"
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"cSREm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, light-dark(rgb(41, 41, 41), rgb(219, 219, 219)))",
            d: "m18.53 17.47-5.083-5.084C14.417 11.186 15 9.66 15 8c0-3.86-3.14-7-7-7S1 4.14 1 8s3.14 7 7 7c1.66 0 3.185-.584 4.386-1.553l5.084 5.083c.146.147.338.22.53.22s.384-.073.53-.22c.293-.293.293-.767 0-1.06M8 13.5c-3.032 0-5.5-2.468-5.5-5.5S4.968 2.5 8 2.5s5.5 2.468 5.5 5.5-2.468 5.5-5.5 5.5"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"eTHST":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, light-dark(rgb(41, 41, 41), rgb(219, 219, 219)))",
                d: "M16.75 5h-5.964c-.218 0-.424-.094-.566-.259L8.516 2.777C8.089 2.283 7.47 2 6.816 2H3.25C2.01 2 1 3.01 1 4.25v10.5C1 15.99 2.01 17 3.25 17h13.5c1.24 0 2.25-1.01 2.25-2.25v-7.5C19 6.01 17.99 5 16.75 5M3.25 3.5h3.565c.218 0 .424.094.567.259L8.459 5H2.5v-.75c0-.413.337-.75.75-.75M17.5 14.75c0 .413-.337.75-.75.75H3.25c-.413 0-.75-.337-.75-.75V6.5h14.25c.413 0 .75.337.75.75z"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, light-dark(rgb(41, 41, 41), rgb(219, 219, 219)))",
                d: "M10 13.65c-.192 0-.384-.073-.53-.22l-3-3c-.293-.292-.293-.767 0-1.06s.767-.293 1.06 0L10 11.84l2.47-2.47c.293-.293.767-.293 1.06 0s.293.768 0 1.06l-3 3c-.146.147-.338.22-.53.22"
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"42COX":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LinkContext", ()=>LinkContext);
parcelHelpers.export(exports, "Link", ()=>Link);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _link = require("react-aria-components/Link");
var _skeleton = require("./Skeleton");
var _useDOMRef = require("./useDOMRef");
var _useLayoutEffect = require("react-aria/private/utils/useLayoutEffect");
var _useSpectrumContextProps = require("./useSpectrumContextProps");
const LinkContext = /*#__PURE__*/ (0, _react.createContext)(null);
const link = function anonymous(props, overrides) {
    let rules = " ";
    rules += (String(overrides || '').match(/(?:^|\s)(J|G|I|H|_u|_v|_s|__A|_d|_J|z|y|B|A|_P|_9|W|_l|_A|_z|_6|Z|N|L)[^\s]+/g) || []).join('');
    if (props.isFocusVisible) rules += ' _Lf18';
    else rules += ' _Le18';
    if (props.isStaticColor) rules += ' Oe18';
    else rules += ' Oh18';
    rules += ' OlOVIhfcebS7sd18';
    rules += ' OlOVIhfcebS7sd18';
    rules += ' _Mc18';
    rules += ' _Kd18';
    if (props.staticColor === "white") rules += ' -Ovbhqd-gcwrnr18';
    else if (props.staticColor === "black") rules += ' -Ovbhqd-g4hn3s18';
    rules += ' oR3ltQc18';
    rules += ' nR3ltQc18';
    rules += ' kR3ltQc18';
    rules += ' jR3ltQc18';
    if (props.isStandalone) {
        rules += ' uk18';
        rules += ' ucJ9TBTb18';
        rules += ' ud3Euai18';
        rules += ' uea18';
        rules += ' ugb18';
        rules += ' uhd18';
        rules += ' uje18';
        rules += ' u2NhKxcl18';
        rules += ' uic18';
    }
    if (props.isStandalone) {
        rules += ' -_6BNtrc-c18';
        rules += ' vFHT6Dd18';
    }
    if (props.isStandalone) {
        rules += ' xc18';
        rules += ' _xa18';
    }
    if (props.isStandalone) {
        rules += ' _Fd18';
        rules += ' _FnuYUweb18';
    }
    if (props.isStaticColor) rules += ' pl18';
    else if (props.variant === "secondary") {
        if (props.isPressed) rules += ' po18';
        else if (props.isFocusVisible) rules += ' po18';
        else if (props.isHovered) rules += ' po18';
        else rules += ' pt18';
    } else if (props.variant === "primary") {
        if (props.isPressed) rules += ' ps18';
        else if (props.isFocusVisible) rules += ' ps18';
        else if (props.isHovered) rules += ' ps18';
        else rules += ' pu18';
    }
    rules += ' plOVIhfcA5Qiqd18';
    rules += ' plOVIhfcA5Qiqd18';
    rules += ' Yd18';
    rules += ' Xb18';
    rules += ' _2b18';
    if (props.isStandalone) {
        if (props.isQuiet) {
            if (props.isFocusVisible) {
                rules += ' _Xb18';
                rules += ' __Va18';
            } else if (props.isHovered) {
                rules += ' _Xb18';
                rules += ' __Va18';
            } else rules += ' _Xa18';
        }
    } else {
        rules += ' _Xb18';
        rules += ' __Va18';
    }
    rules += ' __ca18';
    return rules;
};
const Link = /*#__PURE__*/ (0, _react.forwardRef)(function Link(props, ref) {
    [props, ref] = (0, _useSpectrumContextProps.useSpectrumContextProps)(props, ref, LinkContext);
    let { variant = 'primary', staticColor, isQuiet, isStandalone, UNSAFE_style, UNSAFE_className = '', styles, children } = props;
    let domRef = (0, _useDOMRef.useFocusableRef)(ref);
    let isSkeleton = (0, _react.useContext)((0, _skeleton.SkeletonContext)) || false;
    [children, UNSAFE_style] = (0, _skeleton.useSkeletonText)(children, UNSAFE_style);
    (0, _useLayoutEffect.useLayoutEffect)(()=>{
        if (domRef.current) // TODO: should RAC Link pass through inert?
        domRef.current.inert = isSkeleton;
    }, [
        domRef,
        isSkeleton
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _link.Link), {
        ...props,
        ref: domRef,
        style: UNSAFE_style,
        className: (renderProps)=>UNSAFE_className + link({
                ...renderProps,
                variant,
                staticColor,
                isStaticColor: !!staticColor,
                isQuiet,
                isStandalone,
                isSkeleton
            }, styles),
        children: children
    });
});

},{"0":"dGUmc","react/jsx-runtime":"2Is6Z","react":"a1TxN","react-aria-components/Link":"fOCdV","./Skeleton":"1mUnF","./useDOMRef":"9tqah","react-aria/private/utils/useLayoutEffect":"k6VV7","./useSpectrumContextProps":"8SU0q","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"dGUmc":[function() {},{}],"2mowY":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BadgeContext", ()=>BadgeContext);
parcelHelpers.export(exports, "Badge", ()=>Badge);
var _jsxRuntime = require("react/jsx-runtime");
var _centerBaseline = require("./CenterBaseline");
var _slots = require("react-aria-components/slots");
var _filterDOMProps = require("react-aria/filterDOMProps");
var _icon = require("./Icon");
var _text = require("react-aria-components/Text");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _skeleton = require("./Skeleton");
var _content = require("./Content");
var _useDOMRef = require("./useDOMRef");
var _useSpectrumContextProps = require("./useSpectrumContextProps");
const BadgeContext = /*#__PURE__*/ (0, _react.createContext)(null);
const badge = function anonymous(props, overrides) {
    let rules = " ";
    let minWidth = false;
    let matches = String(overrides || '').matchAll(/(?:^|\s)(J|G|I|H|_u|_v|_s|__A|_d|_J|z|y|B|A|_P|_9|W|_l|_A|_z|_6|Z|N|L)[^\s]+/g);
    for (let p of matches){
        if (p[1] === "N") minWidth = true;
        rules += p[0];
    }
    if (props.size === "XL") {
        rules += ' uk18';
        rules += ' ucJ9TBTb18';
        rules += ' ud3Euai18';
        rules += ' uea18';
        rules += ' ugb18';
        rules += ' uhd18';
        rules += ' uje18';
        rules += ' u2NhKxcl18';
        rules += ' uic18';
    } else if (props.size === "L") {
        rules += ' uk18';
        rules += ' ucJ9TBTb18';
        rules += ' ud3Euai18';
        rules += ' uea18';
        rules += ' ugb18';
        rules += ' uhd18';
        rules += ' uje18';
        rules += ' u2NhKxcl18';
        rules += ' uic18';
    } else if (props.size === "S") {
        rules += ' uk18';
        rules += ' ucJ9TBTb18';
        rules += ' ud3Euai18';
        rules += ' uea18';
        rules += ' ugb18';
        rules += ' uhd18';
        rules += ' uje18';
        rules += ' u2NhKxcl18';
        rules += ' uic18';
    } else if (props.size === "XS") {
        rules += ' uk18';
        rules += ' ucJ9TBTb18';
        rules += ' ud3Euai18';
        rules += ' uea18';
        rules += ' ugb18';
        rules += ' uhd18';
        rules += ' uje18';
        rules += ' u2NhKxcl18';
        rules += ' uic18';
    } else {
        rules += ' uk18';
        rules += ' ucJ9TBTb18';
        rules += ' ud3Euai18';
        rules += ' uea18';
        rules += ' ugb18';
        rules += ' uhd18';
        rules += ' uje18';
        rules += ' u2NhKxcl18';
        rules += ' uic18';
    }
    if (props.size === "XL") {
        rules += ' -_6BNtrc-e18';
        rules += ' vFHT6Dd18';
    } else if (props.size === "L") {
        rules += ' -_6BNtrc-d18';
        rules += ' vFHT6Dd18';
    } else if (props.size === "S") {
        rules += ' -_6BNtrc-b18';
        rules += ' vFHT6Dd18';
    } else if (props.size === "XS") {
        rules += ' -_6BNtrc-a18';
        rules += ' vFHT6Dd18';
    } else {
        rules += ' -_6BNtrc-c18';
        rules += ' vFHT6Dd18';
    }
    if (props.size === "XL") {
        rules += ' xb18';
        rules += ' _xa18';
    } else if (props.size === "L") {
        rules += ' xb18';
        rules += ' _xa18';
    } else if (props.size === "S") {
        rules += ' xb18';
        rules += ' _xa18';
    } else if (props.size === "XS") {
        rules += ' xb18';
        rules += ' _xa18';
    } else {
        rules += ' xb18';
        rules += ' _xa18';
    }
    if (props.size === "XL") {
        rules += ' _Fd18';
        rules += ' _FnuYUweb18';
    } else if (props.size === "L") {
        rules += ' _Fd18';
        rules += ' _FnuYUweb18';
    } else if (props.size === "S") {
        rules += ' _Fd18';
        rules += ' _FnuYUweb18';
    } else if (props.size === "XS") {
        rules += ' _Fd18';
        rules += ' _FnuYUweb18';
    } else {
        rules += ' _Fd18';
        rules += ' _FnuYUweb18';
    }
    if (props.fillStyle === "outline") rules += ' pm18';
    else if (props.fillStyle === "subtle") rules += ' pm18';
    else if (props.fillStyle === "bold") {
        if (props.variant === "celery") rules += ' pg18';
        else if (props.variant === "chartreuse") rules += ' pg18';
        else if (props.variant === "yellow") rules += ' pg18';
        else if (props.variant === "orange") rules += ' pg18';
        else if (props.variant === "notice") rules += ' pg18';
        else rules += ' px18';
    }
    rules += ' sd18';
    rules += ' ea18';
    rules += ' egLWx3bb18';
    rules += ' _oa18';
    rules += ' Sv18';
    rules += ' SgLWx3bd18';
    rules += ' Rv18';
    rules += ' RgLWx3bd18';
    if (props.size === "XL") {
        if (!minWidth) rules += ' NBaYFfc18';
    } else if (props.size === "L") {
        if (!minWidth) rules += ' N3JjxG18';
    } else if (props.size === "S") {
        if (!minWidth) rules += ' NCe2o8c18';
    } else if (props.size === "XS") {
        if (!minWidth) rules += ' NifsFYc18';
    } else if (!minWidth) rules += ' N4dY0ec18';
    if (props.size === "XL") rules += ' -SFnbic-_JaP8ec18';
    else if (props.size === "L") rules += ' -SFnbic-_J0K2hn18';
    else if (props.size === "S") rules += ' -SFnbic-_JJOW22b18';
    else if (props.size === "XS") rules += ' -SFnbic-_JICefdd18';
    else rules += ' -SFnbic-_Jb18';
    rules += ' -Bu7z1c-oH5kTnc18';
    rules += ' oj18';
    rules += ' nj18';
    rules += ' kj18';
    rules += ' jj18';
    rules += ' qc18';
    rules += ' qsd18';
    rules += ' -Qg41Lb-IAxCW0c18';
    rules += ' -Qg41Lb-gLWx3bIYB8I18';
    rules += ' MAyFGYc18';
    rules += ' Td18';
    rules += ' Qd18';
    rules += ' -aRvJDd-Tu7Fubd18';
    rules += ' _Ca18';
    if (props.fillStyle === "outline") rules += ' g_g18';
    else if (props.fillStyle === "subtle") {
        if (props.variant === "silver") rules += ' g_f18';
        else if (props.variant === "cinnamon") rules += ' gP18';
        else if (props.variant === "brown") rules += ' gO18';
        else if (props.variant === "turquoise") rules += ' gy18';
        else if (props.variant === "pink") rules += ' gT18';
        else if (props.variant === "magenta") rules += ' gS18';
        else if (props.variant === "fuchsia") rules += ' gR18';
        else if (props.variant === "purple") rules += ' gM18';
        else if (props.variant === "indigo") rules += ' gK18';
        else if (props.variant === "blue") rules += ' gG18';
        else if (props.variant === "cyan") rules += ' gC18';
        else if (props.variant === "seafoam") rules += ' gz18';
        else if (props.variant === "green") rules += ' gA18';
        else if (props.variant === "celery") rules += ' gv18';
        else if (props.variant === "chartreuse") rules += ' gJ18';
        else if (props.variant === "yellow") rules += ' gW18';
        else if (props.variant === "orange") rules += ' gV18';
        else if (props.variant === "red") rules += ' gU18';
        else if (props.variant === "gray") rules += ' gI18';
        else if (props.variant === "negative") rules += ' gU18';
        else if (props.variant === "notice") rules += ' gV18';
        else if (props.variant === "positive") rules += ' gA18';
        else if (props.variant === "neutral") rules += ' gI18';
        else if (props.variant === "informative") rules += ' gG18';
        else if (props.variant === "accent") rules += ' gG18';
    } else if (props.fillStyle === "bold") {
        if (props.variant === "silver") rules += ' gm18';
        else if (props.variant === "cinnamon") rules += ' gq18';
        else if (props.variant === "brown") rules += ' gn18';
        else if (props.variant === "turquoise") rules += ' g518';
        else if (props.variant === "pink") rules += ' gx18';
        else if (props.variant === "magenta") rules += ' gD18';
        else if (props.variant === "fuchsia") rules += ' gr18';
        else if (props.variant === "purple") rules += ' go18';
        else if (props.variant === "indigo") rules += ' gl18';
        else if (props.variant === "blue") rules += ' g218';
        else if (props.variant === "cyan") rules += ' gk18';
        else if (props.variant === "seafoam") rules += ' g418';
        else if (props.variant === "green") rules += ' g118';
        else if (props.variant === "celery") rules += ' g718';
        else if (props.variant === "chartreuse") rules += ' gp18';
        else if (props.variant === "yellow") rules += ' gN18';
        else if (props.variant === "orange") rules += ' gQ18';
        else if (props.variant === "red") rules += ' gB18';
        else if (props.variant === "gray") rules += ' g618';
        else if (props.variant === "negative") rules += ' gB18';
        else if (props.variant === "notice") rules += ' gQ18';
        else if (props.variant === "positive") rules += ' g118';
        else if (props.variant === "neutral") rules += ' g618';
        else if (props.variant === "informative") rules += ' g218';
        else if (props.variant === "accent") rules += ' g218';
    }
    rules += ' _jf18';
    rules += ' _kJ8iPYd18';
    rules += ' hXMFGYc18';
    rules += ' mc18';
    rules += ' lc18';
    if (props.fillStyle === "outline") {
        if (props.variant === "negative") rules += ' iFLVMS18';
        else if (props.variant === "notice") rules += ' i9VrKkd18';
        else if (props.variant === "positive") rules += ' ip17Jm18';
        else if (props.variant === "neutral") rules += ' i0ruhAb18';
        else if (props.variant === "informative") rules += ' iG1ze4d18';
        else if (props.variant === "accent") rules += ' iG1ze4d18';
        else rules += ' iA18';
    } else rules += ' iA18';
    rules += ' -_8sjo0b-t5ZbAob18';
    if (props.size === "XL") rules += ' -M_-MBaYFfc18';
    else if (props.size === "L") rules += ' -M_-M3JjxG18';
    else if (props.size === "S") rules += ' -M_-MCe2o8c18';
    else if (props.size === "XS") rules += ' -M_-MifsFYc18';
    else rules += ' -M_-M4dY0ec18';
    rules += ' -_k_-_kc18';
    rules += ' -h_-hc18';
    return rules;
};
const Badge = /*#__PURE__*/ (0, _react.forwardRef)(function Badge(props1, ref) {
    [props1, ref] = (0, _useSpectrumContextProps.useSpectrumContextProps)(props1, ref, BadgeContext);
    let { children, variant = 'neutral', size = 'S', fillStyle = 'bold', overflowMode = 'wrap', ...otherProps } = props1; // useProviderProps(props) in v3
    let domRef = (0, _useDOMRef.useDOMRef)(ref);
    let isTextOnly = (0, _reactDefault.default).Children.toArray(props1.children).every((c)=>!/*#__PURE__*/ (0, _reactDefault.default).isValidElement(c));
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _slots.Provider), {
        values: [
            [
                (0, _content.TextContext),
                {
                    styles: function anonymous(props) {
                        let rules = " ";
                        rules += ' TAzEcG18';
                        rules += ' QAzEcG18';
                        rules += ' _Jb18';
                        rules += ' _Nc18';
                        rules += ' Pc18';
                        rules += ' _Yb18';
                        if (props.overflowMode === "wrap") rules += ' _7b18';
                        else if (props.overflowMode === "truncate") rules += ' _7c18';
                        return rules;
                    }({
                        overflowMode
                    })
                }
            ],
            [
                (0, _text.TextContext),
                {}
            ],
            [
                (0, _icon.IconContext),
                {
                    render: (0, _centerBaseline.centerBaseline)({
                        slot: 'icon',
                        styles: " _Ja18"
                    }),
                    styles: " ZObNfn18 FObNfn18 I67logd18 _va18"
                }
            ]
        ],
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _skeleton.SkeletonWrapper), {
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                ...(0, _filterDOMProps.filterDOMProps)(otherProps),
                role: "presentation",
                className: (props1.UNSAFE_className || '') + badge({
                    variant,
                    size,
                    fillStyle
                }, props1.styles),
                style: props1.UNSAFE_style,
                ref: domRef,
                children: typeof children === 'string' || isTextOnly ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _content.Text), {
                    children: children
                }) : children
            })
        })
    });
});

},{"0":"4Zx2m","1":"edtSF","2":"jeZxC","3":"i2kW3","react/jsx-runtime":"2Is6Z","./CenterBaseline":"1vpL9","react-aria-components/slots":"bA6Cz","react-aria/filterDOMProps":"c0Owd","./Icon":"jQAJE","react-aria-components/Text":"jt9fm","react":"a1TxN","./Skeleton":"1mUnF","./Content":"10r6w","./useDOMRef":"9tqah","./useSpectrumContextProps":"8SU0q","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"4Zx2m":[function() {},{}],"edtSF":[function() {},{}],"jeZxC":[function() {},{}],"i2kW3":[function() {},{}],"6hpGX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, light-dark(rgb(41, 41, 41), rgb(219, 219, 219)))",
                d: "M10 18.75c-4.825 0-8.75-3.925-8.75-8.75S5.175 1.25 10 1.25s8.75 3.925 8.75 8.75-3.925 8.75-8.75 8.75m0-16c-3.998 0-7.25 3.252-7.25 7.25s3.252 7.25 7.25 7.25 7.25-3.252 7.25-7.25S13.998 2.75 10 2.75"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, light-dark(rgb(41, 41, 41), rgb(219, 219, 219)))",
                d: "M9.223 13.5c-.212 0-.415-.09-.558-.248l-2.51-2.792c-.278-.309-.253-.782.055-1.06s.781-.252 1.06.056l1.893 2.107 3.487-4.756c.244-.334.711-.41 1.048-.161.334.244.406.713.161 1.047l-4.032 5.5c-.133.183-.342.295-.567.306z"
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"jAv02":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, light-dark(rgb(41, 41, 41), rgb(219, 219, 219)))",
                d: "M10 18.78c-4.825 0-8.75-3.926-8.75-8.75S5.175 1.28 10 1.28s8.75 3.924 8.75 8.75-3.925 8.75-8.75 8.75m0-16c-3.998 0-7.25 3.251-7.25 7.25s3.252 7.25 7.25 7.25 7.25-3.253 7.25-7.25S13.998 2.78 10 2.78"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, light-dark(rgb(41, 41, 41), rgb(219, 219, 219)))",
                d: "M10 14.384c0 .653.615 1.121 1.251.973 2.435-.566 4.249-2.75 4.249-5.357s-1.814-4.79-4.249-5.357c-.636-.148-1.251.32-1.251.973z"
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"8rFkP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, light-dark(rgb(41, 41, 41), rgb(219, 219, 219)))",
            d: "M10 6.35c2.012 0 3.65 1.638 3.65 3.65s-1.638 3.65-3.65 3.65S6.35 12.012 6.35 10 7.988 6.35 10 6.35m0-1.5c-2.84 0-5.15 2.31-5.15 5.15s2.31 5.15 5.15 5.15 5.15-2.31 5.15-5.15S12.84 4.85 10 4.85M10 3.25c-.414 0-.75-.336-.75-.75V1.25c0-.414.336-.75.75-.75s.75.336.75.75V2.5c0 .414-.336.75-.75.75M10 19.5c-.414 0-.75-.336-.75-.75V17.5c0-.414.336-.75.75-.75s.75.336.75.75v1.25c0 .414-.336.75-.75.75M2.5 10.75H1.25c-.414 0-.75-.336-.75-.75s.336-.75.75-.75H2.5c.414 0 .75.336.75.75s-.336.75-.75.75M18.75 10.75H17.5c-.414 0-.75-.336-.75-.75s.336-.75.75-.75h1.25c.414 0 .75.336.75.75s-.336.75-.75.75M15.304 5.446c-.193 0-.384-.073-.53-.22-.294-.292-.294-.767 0-1.06l.883-.884c.293-.293.768-.293 1.06 0s.294.768 0 1.06l-.883.885c-.146.146-.338.22-.53.22M3.813 16.938c-.193 0-.384-.074-.53-.22-.294-.293-.294-.768 0-1.06l.883-.885c.293-.293.768-.293 1.06 0s.294.768 0 1.061l-.883.884c-.147.146-.338.22-.53.22M4.696 5.446c-.192 0-.383-.073-.53-.22l-.884-.883c-.293-.293-.293-.768 0-1.06s.768-.294 1.06 0l.885.883c.293.293.293.768 0 1.06-.147.147-.338.22-.53.22M16.188 16.938c-.193 0-.384-.074-.53-.22l-.885-.884c-.293-.293-.293-.768 0-1.06s.768-.294 1.061 0l.884.883c.293.293.293.768 0 1.06-.147.147-.338.22-.53.22"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"bneuv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, light-dark(rgb(41, 41, 41), rgb(219, 219, 219)))",
            d: "M16.25 14H3.75c-.414 0-.75.336-.75.75s.336.75.75.75h12.5c.414 0 .75-.336.75-.75s-.336-.75-.75-.75M3.75 5.5h12.5c.414 0 .75-.336.75-.75S16.664 4 16.25 4H3.75c-.414 0-.75.336-.75.75s.336.75.75.75M16.25 9H3.75c-.414 0-.75.336-.75.75s.336.75.75.75h12.5c.414 0 .75-.336.75-.75S16.664 9 16.25 9"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}]},[], null, "parcelRequire7f0c", {})

//# sourceMappingURL=useProgressBar.778d2dad.js.map
